import { render } from "./car-search-pagination.vue?vue&type=template&id=8631fcdc&ts=true"
import script from "./car-search-pagination.vue?vue&type=script&lang=ts"
export * from "./car-search-pagination.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__